import { ResponsivePie } from "@nivo/pie";
import { tokens } from "../theme";
import { useTheme } from "@mui/material";
import { mockPieData as data } from "../data/mockData";

const PieChart = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <ResponsivePie
      data={data}
      theme={{
        axis: {
          domain: {
            line: {
              stroke: colors.grey[300],
            },
          },
          legend: {
            text: {
              fill: colors.grey[300],
            },
          },
          ticks: {
            line: {
              stroke: colors.grey[300],
              strokeWidth: 1,
            },
            text: {
              fill: colors.grey[300],
            },
          },
        },
        legends: {
          text: {
            fill: colors.grey[300],
          },
        },
      }}
      margin={{ top: 50, right: 80, bottom: 50, left: 80 }}
      innerRadius={0.4}
      padAngle={1}
      cornerRadius={5}
      activeOuterRadiusOffset={10}
      borderColor={{
        from: "color",
        modifiers: [["darker", 0.3]],
      }}
      arcLinkLabelsSkipAngle={12}
      arcLinkLabelsTextColor={colors.grey[200]}
      arcLinkLabelsThickness={3}
      arcLinkLabelsColor={{ from: "color" }}
      enableArcLabels={true}
      arcLabelsRadiusOffset={0.55}
      arcLabelsSkipAngle={5}
      arcLabelsTextColor={{
        from: "color",
        modifiers: [["darker", 3]],
      }}
      defs={[
        {
          id: "dots",
          type: "patternDots",
          background: "inherit",
          color: "rgba(255, 255, 255, 0.5)",
          size: 6,
          padding: 2,
          stagger: true,
        },
        {
          id: "lines",
          type: "patternLines",
          background: "inherit",
          color: "rgba(255, 255, 255, 0.5)",
          rotation: -30,
          lineWidth: 4,
          spacing: 8,
        },
      ]}
      legends={[
        {
          anchor: "bottom",
          direction: "row",
          justify: false,
          translateX: 0,
          translateY: 60,
          itemsSpacing: 10,
          itemWidth: 120,
          itemHeight: 20,
          itemTextColor: colors.grey[300],
          itemDirection: "left-to-right",
          itemOpacity: 0.9,
          symbolSize: 20,
          symbolShape: "circle",
          effects: [
            {
              on: "hover",
              style: {
                itemTextColor: colors.primary[500],
              },
            },
          ],
        },
      ]}
      animate={true}
      motionConfig="slow"
    />
  );
};

export default PieChart;
